import type { SVGProps } from 'react';
const SvgEject = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#eject_svg__a)">
      <path fill="currentColor" d="M5 17h14v2H5v-2Zm7-12L5.33 15h13.34L12 5Z" />
    </g>
    <defs>
      <clipPath id="eject_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEject;
